const key = "proxy-file-uploader";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/[0-9]*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Schema: {
			...resp.data.Data.Schema,
			properties: {
				...resp.data.Data.Schema.properties,
				blob: {
					format: "base64",
					title: "File Upload",
					type: "string",
					maxSize: "10000000"
				}
			}
		},
		Form: [
			{
				key: "blob",
				placeholder: "Click here or drop files to upload"
			}
		]
	};

	return resp;
};

export const addProxyFileUploader = [key, applicable, modify];